import { render, staticRenderFns } from "./ComponentsOfNeedTable.vue?vue&type=template&id=58b5989b&"
import script from "./ComponentsOfNeedTable.js?vue&type=script&lang=js&"
export * from "./ComponentsOfNeedTable.js?vue&type=script&lang=js&"
import style0 from "./ComponentsOfNeedTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VIcon,VRow,VSelect,VSimpleCheckbox})
